module.exports = __webpack_public_path__ + "static/media/the-times-of-india.ca196704.jpg";